import { UIPosition } from 'types';
import { PositionSkill } from './PositionDrawer';
import SkillComparisonTable from 'src/components/shared/SkillComparisonTable';
import SkillComparisonBarChart from 'src/components/shared/SkillComparisonBarChart';

interface Props {
	position: UIPosition;
	positionSkills: PositionSkill[];
}

const OverallSkillsRequired = ({ position, positionSkills }: Props) => {
	return (
		<>
			{positionSkills && positionSkills?.length > 0 ? (
				<div className="mb-[24px] rounded-[8px] dark:bg-[#1F2A37] bg-[#FAFAFC]">
					<div className="text-lg font-medium dark:text-[#CCDDFF] text-[#1F3343]">Overall Skills required</div>

					{positionSkills.length <= 2 ? (
						<div className="mt-4">
							<SkillComparisonBarChart
								positionSkills={positionSkills || []}
								companyName={position?.company.name || 'Company'}
							/>
						</div>
					) : (
						<SkillComparisonTable positionSkills={positionSkills || []} onlyDesktop={true} />
					)}

					<SkillComparisonTable positionSkills={positionSkills || []} onlyDesktop={false} />
				</div>
			) : null}
		</>
	);
};

export default OverallSkillsRequired;
